import { Col, Form, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListInsurersQuery } from '@/core/domain/people/Insurers/Insurers.types';
import { useIntl } from 'react-intl';

const InsurersSelectedFilters: React.FC<
  ExtraFiltersProps<ListInsurersQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={8}>
            <Col span={12}>
              <Input
                name="cnpj"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, cnpj: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'insurers.filters.cnpj',
                })}
              />
            </Col>

            <Col span={12}>
              <OrderExtraFilter
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,

                    order: value,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default InsurersSelectedFilters;
